module.exports = __webpack_public_path__ + "img/title-MOS.3d3967f8.png";